export const ACTION_TYPES = {
    SET_FILTERS: 'setFilters',
    SET_FILTER: 'setFilter',
    INIT_FILTERS_FROM_QUERY: 'initFiltersFromQuery',
    RESET_ALL_FILTERS: 'resetAllFilters'
};